import { WidgetType } from 'shared/widgets/utils';

import { createNewSelectionQuestionData } from './create';
import { manifestLocales } from './manifest.locales';
import MultiChoiceEn from './resources/en/multi-choice.svg';
import MultiChoiceHe from './resources/he/multi-choice.svg';
import { QuestionsCheckbox } from '@/icons/QuestionsCheckbox';
import { ManifestType } from '@/types/ManifestType';

export const Manifest: ManifestType = {
  name: WidgetType.SelectionQuestion,
  previewGroups: [
    {
      id: 'selectionQuestion',
      divider: {
        icon: QuestionsCheckbox,
        title: 'selectionQuestion'
      },
      previews: [
        {
          name: 'multiChoicePreview',
          previewImage: {
            paths: {
              en: MultiChoiceEn,
              he: MultiChoiceHe
            },
            size: {
              width: 140,
              height: 122
            },
            alt: { ...manifestLocales.multiChoice.previewMultiChoiceAlt }
          },
          dimensions: {
            width: 1180,
            height: 'auto'
          },
          initializeProps: createNewSelectionQuestionData
        }
      ]
    }
  ],
  additionalData: {
    constraints: {
      minHeight: 48,
      minWidth: 100
    }
  }
};
